module.exports = __webpack_public_path__ + "static/media/youtube.282b2e09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/components/Social/images/youtube.svg
// module id = 814
// module chunks = 0